import React from 'react';
import HomeHero from './HomeHero';
import HomeAbout from './HomeAbout';
import HomeClasses from './HomeClasses';
import HomeBMI from './HomeBMI';
import HomePricePlan from './HomePricePlan';
import HomeContact from './HomeContact';
const Home = () => {
  return (
    <>
    <HomeHero />
    <HomeAbout />
    <HomeBMI />
    <HomeClasses />
    <HomeContact />
    <HomePricePlan />
    </>
  );
};

export default Home;
